import { useState, useEffect } from "react";
import * as FeatherIcon from "react-feather";
import { useParams } from "react-router-dom";

const Competitors = ({ onNext, onPrev, updateData, data }) => {
  const { clientName, competitorName } = useParams();
  const defaultSuggested = [
    {
      name: competitorName ?? "Tailored Chemical Products",
      type: "Direct competitor",
    },
    // { name: "McKesson", type: "Traditional competitor" },
    { name: "AmerisourceBergen", type: "Traditional competitor" },
  ];
  const [selectedSuggested, setSelectedSuggested] = useState(
    () => new Set(data.selectedSuggested || [])
  );
  const [customCompetitors, setCustomCompetitors] = useState(
    data.customCompetitors || ""
  );

  useEffect(() => {
    updateData({
      selectedSuggested: Array.from(selectedSuggested),
      customCompetitors,
    });
  }, [selectedSuggested, customCompetitors]);

  const toggleSuggested = (name) => {
    setSelectedSuggested((prev) => {
      const updated = new Set(prev);
      updated.has(name) ? updated.delete(name) : updated.add(name);
      return updated;
    });
  };

  const isSelected = (name) => selectedSuggested.has(name);

  return (
    <div className="wizard_four">
      <h5 className="mb-3 custom_lable">Suggested Primary Competitors</h5>
      <div className="competitors_block">
        <div className="row">
          {defaultSuggested.map((comp, idx) => (
            <div className="col-md-6">
              <div
                key={idx}
                className={`comp_block_input ${
                  isSelected(comp.name)
                    ? "comp_block_input_click"
                    : "comp_block_input_unclick"
                }`}
                onClick={() => toggleSuggested(comp.name)}
              >
                <div className="form-check">
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={isSelected(comp.name)}
                    readOnly
                  />
                </div>
                <div className="direct_comp_lable_block">
                  <label className="form-check-label fw-semibold">
                    {comp.name}
                  </label>
                  <p className="direct_comp_lable">{comp.type}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <h5 className="mb-2 custom_lable">Add Custom Competitors</h5>
      <input
        type="text"
        className="form-control mb-4 custom_input_text"
        placeholder="Enter competitor name separated by commas"
        value={customCompetitors}
        onChange={(e) => setCustomCompetitors(e.target.value)}
      />

      <div className="mt-4">
        <button
          className="btn btn-secondary me-2 previous_btn_wz"
          onClick={onPrev}
        >
          <FeatherIcon.ChevronLeft className="prev_feather" /> Previous
        </button>
        <button className="btn btn-primary next_btn_wz" onClick={onNext}>
          Next <FeatherIcon.ChevronRight className="next_feather" />
        </button>
      </div>
    </div>
  );
};

export default Competitors;
